import { useDnD } from "./contextProvider";


export default ({data}:any) => {
    const [_, setDndNode] = useDnD();

  const onDragStart = (event:any,node:any) => {
    setDndNode?.(node);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <aside>
      <div className="description"></div>
      {
        data.map((node:any, index:number) => (
          <div key={index} className="dndnode" onDragStart={(event) => onDragStart(event,node)} draggable>
            {data[index].thingName}
          </div>
        ))
      }
      {/* <div className="dndnode input" onDragStart={(event) => onDragStart(event)} draggable>
        Input Node
      </div>
      <div className="dndnode" onDragStart={(event) => onDragStart(event)} draggable>
        Default Node
      </div>
      <div className="dndnode output" onDragStart={(event) => onDragStart(event)} draggable>
        Output Node
      </div> */}
    </aside>
  );
};